export default __webpack_public_path__ + "static/media/6-mobile.282a2083.png";